import React, { useState, useRef, useMemo } from "react";
import Sidenav from "../../common/Sidenav";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import {
  Grid,
  Button,
  InputLabel,
  Typography,
  TextField,
  Box,
  Card,
  Divider,
  Snackbar,
  Alert,
  useMediaQuery,
  MenuItem,
  Select,
} from "@mui/material";

import Header from "../../common/Header";
import { Add as PlusIcon, List as ListIcon } from "@mui/icons-material";
import NavigatedComponent from "../NavigatedComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { DropzoneArea } from "mui-file-dropzone";
import { apiList, invokeApi } from "../../../services/apiServices";
import { config } from "../../../config/config";
import { useCookies } from "react-cookie";
import IconSidenav from "../../common/IconSidenav";
import JoditEditor from "jodit-react";

const AddBlog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies] = useCookies();
  const [bannerImage, setBannerImage] = useState("");
  const [featuredImage, setFeaturedImage] = useState("");
  const [selectedBannerImage, setSelectedBannerImage] = useState("");
  const [selectedFeaturedImage, setSelectedFeaturedImage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const isMobileScreen = useMediaQuery(
    "(min-width:360px) and (max-width:500px)"
  );
  const editorRef = useRef(null);

  const [blog, setBlog] = useState({
    blogTitle: "",
    blogContent: "",
    tableOfContent: "",
    ogUrl: "",
    category: "--Select--",
    bannerUrl: "",
    featuredUrl: "",
  });
  const [showSideNav, setShowSideNav] = useState(false);

  const toggleSideNav = () => {
    setShowSideNav(!showSideNav);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBlog((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleBlogContentChange = (value) => {
    setBlog((prevState) => ({
      ...prevState,
      blogContent: value,
    }));
  };

  const handleTableOfContentContentChange = (value) => {
    setBlog((prevState) => ({
      ...prevState,
      tableOfContent: value,
    }));
  };

  const handleBannerImage = (files) => {
    if (files && files.length > 0) {
      const selectedBannerFile = files[0];
      setBannerImage(selectedBannerFile);
      setSelectedBannerImage(selectedBannerFile.name);
    } else {
      setBannerImage(null);
      setSelectedBannerImage("");
    }
  };

  const handleFeaturedImage = (files) => {
    if (files && files.length > 0) {
      const selectedFeaturedFile = files[0];
      setFeaturedImage(selectedFeaturedFile);
      setSelectedFeaturedImage(selectedFeaturedFile.name);
    } else {
      setFeaturedImage(null);
      setSelectedFeaturedImage("");
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleAddBannerImage = async () => {
    const formData = new FormData();
    formData.append("banner", bannerImage);
    try {
      const response = await fetch(
        `https://api.reef.org.in/addBlogBanner`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response?.status >= 200 && response?.status < 300) {
        const responseData = await response.json();
        return responseData.bannerUrl || "";
      } else {
        showSnackbar("Failed to add college banner", "error");
      }
    } catch (error) {
      showSnackbar("Something went wrong. Please try again later.", "error");
    }
  };

  const handleAddCollegeFeatured = async () => {
    const formData = new FormData();
    formData.append("featured", featuredImage);
    try {
      const response = await fetch(
        "https://api.reef.org.in/addBlogFeaturedImage",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response?.status >= 200 && response?.status < 300) {
        const responseData = await response.json();
        return responseData.imageUrl || "";
      } else {
        showSnackbar("Failed to add college featured image", "error");
      }
    } catch (error) {
      showSnackbar("Something went wrong. Please try again later.", "error");
    }
  };

  const handleAddBlog = async (bannerUrl, featuredUrl) => {
    const params = {
      ...blog,
      bannerUrl,
      featuredUrl,
    };

    try {
      const response = await invokeApi(
        config.getMyCollege + apiList.addBlog,
        params,
        cookies
      );
      console.log(params);
      if (response?.status >= 200 && response?.status < 300) {
        if (response.data.responseCode === "200") {
          showSnackbar("Blog Added successfully", "success");
          navigate("/blog-manager/blog-list");
        } else if (response.data.responseCode === "400") {
          showSnackbar(response.data.message, "error");
        }
      }
    } catch (error) {
      console.error("Error during adding college:", error);
      showSnackbar("Something went wrong. Please try again later!!", "error");
    }
  };

  const handleBlogSubmit = async (event) => {
    event.preventDefault();
    try {
      const bannerUrl = await handleAddBannerImage();
      const featuredUrl = await handleAddCollegeFeatured();
      await handleAddBlog(bannerUrl, featuredUrl);
    } catch (error) {
      console.error("Error while adding college details:", error);
      showSnackbar("Something went wrong. Please try again later.", "error");
    }
  };

  return (
    <>
      <Grid sx={{ display: "flex" }}>
        {isMobileScreen ? (
          <IconSidenav />
        ) : showSideNav ? (
          <IconSidenav />
        ) : (
          <Sidenav />
        )}
        <Grid component="main" sx={{ width: "100%", px: 1 }}>
          <Header toggleSideNav={toggleSideNav} />
          <Grid sx={{ py: 1 }}>
            <NavigatedComponent pathname={location.pathname} />
            <Grid sx={{ width: "100%", px: isMobileScreen ? 1 : 5 }}>
              <Card elevation={1} sx={{ my: 5 }}>
                <Grid sx={{ py: isMobileScreen ? 2 : 2 }}>
                  <Typography
                    sx={{
                      mb: 2,
                      mx: isMobileScreen ? 2 : 8,
                      textAlign: "left",
                      fontSize: isMobileScreen ? 14 : 18,
                      fontWeight: 600,
                      // textDecorationLine: "underline",
                      textTransform: "uppercase",
                    }}
                  >
                    Create New Blog
                  </Typography>
                  <Divider sx={{ mb: 3 }} />
                  <form onSubmit={handleBlogSubmit}>
                    <Grid
                      container
                      md={12}
                      xs={12}
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        my: 2,
                      }}
                    >
                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Blog Title *
                        </InputLabel>
                        <TextField
                          placeholder="Enter Blog Title"
                          fullWidth
                          name="blogTitle"
                          value={blog.blogTitle}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          OG URL *
                        </InputLabel>
                        <TextField
                          placeholder=""
                          fullWidth
                          name="ogUrl"
                          value={blog.ogUrl}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Category *
                        </InputLabel>
                        <Select
                          fullWidth
                          name="category"
                          value={blog.category}
                          onChange={handleInputChange}
                          style={{
                            height: isMobileScreen ? "35px" : "40px",
                            fontSize: isMobileScreen ? 12 : 14,
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: "200px",
                              },
                            },
                          }}
                        >
                          <MenuItem value="--Select--" disabled>
                            --Select--
                          </MenuItem>
                          <MenuItem
                            value={"Beach Destinations"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Beach Destinations
                          </MenuItem>
                          <MenuItem
                            value={"Mountain Adventures"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Mountain Adventures
                          </MenuItem>
                          <MenuItem
                            value={"Cultural Tours"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Cultural Tours
                          </MenuItem>
                          <MenuItem
                            value={"Wildlife Safaris"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Wildlife Safaris
                          </MenuItem>
                          <MenuItem
                            value={"Luxury Resorts"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Luxury Resorts
                          </MenuItem>
                          <MenuItem
                            value={"Historical Sites"}
                            style={{ fontSize: isMobileScreen ? 12 : 14 }}
                          >
                            Historical Sites
                          </MenuItem>
                        </Select>
                      </Grid>
                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Table of Content
                        </InputLabel>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            my: isMobileScreen ? 2 : 2,
                            mb: isMobileScreen ? 15 : 1,
                          }}
                        >
                          <JoditEditor
                            ref={editorRef}
                            value={blog.tableOfContent}
                            tabIndex={1}
                            onChange={handleTableOfContentContentChange}
                          />
                        </Grid>
                      </Grid>
                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Blog Content
                        </InputLabel>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            my: isMobileScreen ? 2 : 2,
                            mb: isMobileScreen ? 15 : 1,
                          }}
                        >
                          <JoditEditor
                            ref={editorRef}
                            value={blog.blogContent}
                            tabIndex={1}
                            onChange={handleBlogContentChange}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        md={12}
                        sx={{
                          width: "100%",
                          justifyContent: "space-around",
                          my: 5,
                        }}
                      >
                        <Grid item md={2} xs={11}>
                          <InputLabel
                            sx={{
                              fontWeight: "bold",
                              my: 1,
                              fontSize: isMobileScreen ? 12 : 15,
                            }}
                          >
                            Banner Image
                          </InputLabel>
                          <Grid
                            sx={{
                              my: 4,
                              ".MuiBox-root ": {
                                bgcolor: "#f0f8ff",
                                borderColor: "#1d1a57",
                                minHeight: 0,
                                my: 1,
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <DropzoneArea
                              filesLimit={1}
                              acceptedFiles={["image/jpeg", "image/png"]}
                              onChange={handleBannerImage}
                              maxFileSize={5000000}
                              showPreviews={true}
                              showAlerts={false}
                              showPreviewsInDropzone={false}
                              showFileNames={false}
                              Icon={(props) => (
                                <CloudUploadIcon
                                  style={{
                                    color: "#1d1a57",
                                    width: 35,
                                    height: 35,
                                  }}
                                  {...props}
                                />
                              )}
                              dropzoneText={
                                <Typography
                                  sx={{
                                    color: "#1d1a57",
                                    fontWeight: 600,
                                    fontSize: 16,
                                  }}
                                >
                                  Upload / Drag files
                                </Typography>
                              }
                              previewText="Selected Banner Image:"
                            />
                          </Grid>
                        </Grid>
                        <Grid item md={2} xs={11}>
                          <InputLabel
                            sx={{
                              fontWeight: "bold",
                              my: 1,
                              fontSize: isMobileScreen ? 12 : 15,
                            }}
                          >
                            Featured Image
                          </InputLabel>
                          <InputLabel></InputLabel>
                          <Grid
                            sx={{
                              my: 4,
                              ".MuiBox-root ": {
                                bgcolor: "#f0f8ff",
                                borderColor: "#1d1a57",
                                minHeight: 0,
                                my: 1,
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <DropzoneArea
                              filesLimit={1}
                              onChange={handleFeaturedImage}
                              acceptedFiles={["image/jpeg", "image/png"]}
                              maxFileSize={5000000}
                              showPreviews={true}
                              showAlerts={false}
                              showPreviewsInDropzone={false}
                              showFileNames={false}
                              Icon={(props) => (
                                <CloudUploadIcon
                                  style={{
                                    color: "#1d1a57",
                                    width: 35,
                                    height: 35,
                                  }}
                                  {...props}
                                />
                              )}
                              dropzoneText={
                                <Typography
                                  sx={{
                                    color: "#1d1a57",
                                    fontWeight: 600,
                                    fontSize: 16,
                                  }}
                                >
                                  Upload / Drag files
                                </Typography>
                              }
                              previewText="Selected Featured Image:"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      md={12}
                      xs={12}
                      sx={{
                        width: "100%",
                      }}
                    ></Grid>
                    <Divider sx={{ mb: 1 }} />
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="submit"
                        sx={{
                          my: 2,
                          px: 2,
                          fontSize: 12,
                          background: "#1d1a57",
                          color: "#FFF",
                          fontWeight: 600,
                          "&:hover": {
                            background: "#1d1a57",
                            color: "#FFF",
                          },
                        }}
                      >
                        <DriveFolderUploadIcon />
                        &nbsp; Publish
                      </Button>
                    </Grid>
                  </form>
                </Grid>
              </Card>
              {/* Snackbar */}
              <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={handleCloseSnackbar}
                  severity={snackbarSeverity}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AddBlog;
